
import { Box } from '@mui/material';
import { styled, keyframes } from '@mui/material/styles';

const animationItem = keyframes`
  0% { opacity: 0; transform: translateX(-2rem); } 
  3% { opacity: 1; transform: translateX(0); } 
  80% { opacity: 1; transform: translateX(0); } 
  98% { opacity: 0; transform: translateX(0); } 
`;

const StyledBox = styled(Box)(({ theme }) => ({
  '&.announcementBar': {
    backgroundColor: theme.palette.secondary.dark,
    color: theme.palette.common.white,
    padding: theme.spacing(1),
    borderRadius: theme.spacing(0.25),
    position: 'relative',
    display: 'flex',
    marginTop: theme.spacing(1),
    [theme.breakpoints.down('md')]: {
      height: theme.spacing(10),
    },
    '& .announcementItem': {
      color: theme.palette.common.white,
      opacity: 0,
      transform: 'translateX(-2rem)',
      animation: `${animationItem} 5s ease-in infinite`,
      fontSize: theme.spacing(1.75),
      position:'relative',
      top: theme.typography.pxToRem(2),
      [theme.breakpoints.down('md')]: {
        height: theme.typography.pxToRem(40),
      },
      [theme.breakpoints.down('sm')]: {
        height: theme.typography.pxToRem(50),
      },
      [theme.breakpoints.down('xs')]: {
        height: theme.typography.pxToRem(70),
      },
    },
    '& .announcementIcon': {
      color: theme.palette.primary.main,
      paddingRight: theme.spacing(0.5),
    },
  },
  '&.announcementBarVertical': {
    height: theme.spacing(10),
  },
}));
export default StyledBox;